import { WIN_LABEL_STYLE } from '@/containers/common/TextStyles'
import { TweenUtils } from '@/utils/TweenUtils'
import { toMoney } from '@base/utils/Formatter'
import gsap from 'gsap'
import * as PIXI from 'pixi.js'
import { ScalingTextField } from '@/containers/common/ScalingTextField'
import { toMajorUnits } from '@/utils/CurrencyUnits'

export class WinLabel extends PIXI.Container {
    private readonly _valueTxt: ScalingTextField
    private _isActive: boolean

    public constructor() {
        super()

        this._valueTxt = new ScalingTextField(1, 350, PIXI.Text, WIN_LABEL_STYLE)
        this.addChild(this._valueTxt)

        this._isActive = false
    }

    public init = () => {
        this.alpha = 1
        this._isActive = false
    }

    public reset = () => {}

    public changeValue(value: number) {
        if (this._isActive) {
            return
        }

        this._valueTxt.text = toMoney(toMajorUnits(value), 2)
    }

    public showLabel() {
        if (this._isActive) {
            return
        }
        TweenUtils.fadeIn(this, 0.5)
        this._isActive = true
    }

    public hideLabel(onComplete?: Function) {
        if (!this._isActive) {
            return
        }

        const y: number = this.y

        TweenUtils.fadeOut(this, 1)
        gsap.to(this, {
            duration: 1,
            y: y - 40,
            onComplete: () => {
                this._isActive = false
                this.visible = false
                if (onComplete) {
                    onComplete()
                }
            },
        })
    }
}
